// extracted by mini-css-extract-plugin
export var filterIncDec = "_4g-0";
export var leftBorder = "_4g-1";
export var rightBorder = "_4g-2";
export var stringInput = "_4g-3";